import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPrev, 
  onNext, 
  onPageChange,
  type = 'movies', // 'movies' or 'series'
  cooldown = false // new prop
}) => {
  const pageInputId = `${type}PageInput`;
  const currentPageId = `${type}CurrentPage`;
  const totalPagesId = `${type}TotalPages`;
  const prevPageId = `${type}PrevPage`;
  const nextPageId = `${type}NextPage`;
  const goToPageId = `${type}GoToPage`;

  return (
    <div className={`pagination-container ${cooldown ? 'cooldown' : ''}`}>
      <button 
        id={prevPageId}
        className="pagination-btn" 
        disabled={currentPage <= 1 || cooldown}
        onClick={onPrev}
      >
        <FontAwesomeIcon icon={faChevronLeft} /> Back
      </button>
      
      <div className="page-info">
        <span>Page</span>
        <span id={currentPageId}>{currentPage}</span>
        <span>of</span>
        <span id={totalPagesId}>{totalPages}</span>
      </div>
      
      <button 
        id={nextPageId}
        className="pagination-btn" 
        disabled={currentPage >= totalPages || cooldown}
        onClick={onNext}
      >
        Next  <FontAwesomeIcon icon={faChevronRight} />
      </button>
      
      <div className="page-info">
        <input 
          type="number" 
          id={pageInputId}
          className="page-input" 
          min="1" 
          max="500" 
          defaultValue={currentPage}
          disabled={cooldown}
          onKeyUp={(e) => {
            if (e.key === 'Enter') {
              const page = parseInt(e.target.value);
              if (!isNaN(page)) {
                onPageChange(page);
              }
            }
          }}
        />
        <button 
          id={goToPageId}
          className="go-to-page-btn"
          disabled={cooldown}
          onClick={() => {
            const input = document.getElementById(pageInputId);
            const page = parseInt(input.value);
            if (!isNaN(page)) {
              onPageChange(page);
            }
          }}
        >
          Go
        </button>
      </div>
    </div>
  );
};

export default Pagination;